import Crud from '../components/Ask/Crud'
import Ask from '../components/Ask/Ask'

let routes = {
    path: '/asks',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/asks/:operation?/:id?',
          name: 'Perguntas',
          component: Crud
      },
      {
          path: '/ask/:id?',
          name: 'Pergunta',
          component: Ask
      },
    ],
}

export default routes


// WEBPACK FOOTER //
// ./src/router/ask.js